export const videos = [
  {
    url: 'https://vimeo.com/23293646',
    metadata: {
      width: 640,
      height: 360,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F23293646%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F23293646&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F152828646_640.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=vimeo" width="640" height="360" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'LONELY PLANET - Get Out',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/152828646_640.jpg',
      description:
        'Viral spec commercial created for Lonely Planet out of footage previously shot by us that was waiting to be used. After years of working for clients and ideas I didn´t always agree, this time I wanted to send a message I actually believe in, to show the spirit that moves me.',
      author_name: 'Ernex',
    },
  },
  {
    url: 'https://vimeo.com/37217621',
    metadata: {
      width: 640,
      height: 360,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F37217621%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F37217621&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F255573559_640.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=vimeo" width="640" height="360" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'LONELY PLANET',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/255573559_640.jpg',
      description:
        'This is "LONELY PLANET" by Multi Channel Network on Vimeo, the home for high quality videos and the people who love them.',
      author_name: 'Multi Channel Network',
    },
  },
  {
    url: 'https://vimeo.com/135534096',
    metadata: {
      width: 1920,
      height: 1080,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F135534096%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F135534096&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F531295823_1280.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=vimeo" width="1920" height="1080" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'Webflow CMS Concept Video',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/531295823_1280.jpg',
      description:
        "Meet the world's first visual CMS. Build fully customizable, dynamic websites. Without writing a line of code.",
      author_name: 'Webflow',
    },
  },
  {
    url: 'https://vimeo.com/99876106',
    metadata: {
      width: 1280,
      height: 720,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F99876106%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F99876106&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F481205349_1280.jpg&key=c4e54deccf4d4ec997a64902e9a30300&type=text%2Fhtml&schema=vimeo" width="1280" height="720" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'Elements of Design',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/481205349_1280.jpg',
      description:
        'Animation & Design - Matt Greenwood - http://mattgreenwood.tv Music by Proem - http://www.proemland.com',
      author_name: 'matt greenwood',
    },
  },
  {
    url: 'https://vimeo.com/5867030',
    metadata: {
      width: 640,
      height: 368,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F5867030%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F5867030&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F20640826_640.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=vimeo" width="640" height="368" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'Kite',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/20640826_640.jpg',
      description: 'Dave tries to fly a kite.',
      author_name: 'timothy heath',
    },
  },
  {
    url: 'https://vimeo.com/79988821',
    metadata: {
      width: 1280,
      height: 720,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F79988821%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F79988821&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F455809692_1280.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=vimeo" width="1280" height="720" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'Design Starts Here',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/455809692_1280.jpg',
      description:
        'Design Starts Here is my graduation project for the MA Graphic Moving Image course at London College of Communication. From my research into the motion design and graphic design industries, I have often discovered that many people place too much of an emphasis on software.',
      author_name: 'Elias Freiberger',
    },
  },
  {
    url: 'https://vimeo.com/75406915',
    metadata: {
      width: 1280,
      height: 720,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F75406915%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F75406915&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F449957095_1280.jpg&key=c4e54deccf4d4ec997a64902e9a30300&type=text%2Fhtml&schema=vimeo" width="1280" height="720" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'Motion Experiment',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/449957095_1280.jpg',
      description:
        'This is a 3D animation following the idea of my first self promotional piece. (http://vimeo.com/29319721) Limiting myself to the use of only a few plain colors I tried to create a 3D animation still giving an idea of depth. By combining graphical and organic shapes I tried to achieve a dynamic and cheerful style.',
      author_name: 'Elias Freiberger',
    },
  },
  {
    url: 'https://www.youtube.com/watch?v=ipR6xq3ZjII&list=PLPmnoMVpkxfhSuCJx77M5ecapPhBHF0-v',
    metadata: {
      width: 854,
      height: 480,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fwww.youtube.com%2Fembed%2Fvideoseries%3Flist%3DPLPmnoMVpkxfhSuCJx77M5ecapPhBHF0-v&url=http%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DipR6xq3ZjII&image=https%3A%2F%2Fi.ytimg.com%2Fvi%2FipR6xq3ZjII%2Fhqdefault.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=youtube" width="854" height="480" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'Dynamic content for beginners - Webflow CMS tutorial',
      provider_name: 'YouTube',
      type: 'video',
      thumbnail_url: 'https://i.ytimg.com/vi/ipR6xq3ZjII/hqdefault.jpg',
      description:
        "In this video, we'll explain the differences between static and dynamic content, and learn why the latter is so useful for some of the most popular content types on the web, from blog posts to product pages. ---------- Get started with Webflow: https://help.webflow.com/courses/getting-started http://webflow.com http://twitter.com/webflow http://facebook.com/webflow",
      author_name: 'Webflow',
    },
  },
  {
    url: 'https://www.youtube.com/watch?v=KZQMMLh8YM4',
    metadata: {
      width: 854,
      height: 480,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fwww.youtube.com%2Fembed%2FKZQMMLh8YM4%3Ffeature%3Doembed&url=http%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DKZQMMLh8YM4&image=https%3A%2F%2Fi.ytimg.com%2Fvi%2FKZQMMLh8YM4%2Fhqdefault.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=youtube" width="854" height="480" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: "Webflow: Design websites. Don't code them.",
      provider_name: 'YouTube',
      type: 'video',
      thumbnail_url: 'https://i.ytimg.com/vi/KZQMMLh8YM4/hqdefault.jpg',
      description:
        'Webflow empowers designers to bring their visions to life-without writing a single line of code. Or relying on developers. Plus, with the all-new, all-visual Webflow CMS, designers can build custom, dynamic websites and let their clients add and edit content with an intuitive on-page editor.',
      author_name: 'Webflow',
    },
  },
  {
    url: 'https://www.youtube.com/watch?v=obiVCKtcXbs',
    metadata: {
      width: 854,
      height: 480,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fwww.youtube.com%2Fembed%2FobiVCKtcXbs%3Ffeature%3Doembed&url=http%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DobiVCKtcXbs&image=https%3A%2F%2Fi.ytimg.com%2Fvi%2FobiVCKtcXbs%2Fhqdefault.jpg&key=c4e54deccf4d4ec997a64902e9a30300&type=text%2Fhtml&schema=youtube" width="854" height="480" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'Why Use Webflow',
      provider_name: 'YouTube',
      type: 'video',
      thumbnail_url: 'https://i.ytimg.com/vi/obiVCKtcXbs/hqdefault.jpg',
      description:
        'Learn how to build Custom designed websites with Webflow: http://zpr.io/g8yBb - Webflow completely changed the way I design and develop websites.',
      author_name: 'Flux',
    },
  },
  {
    url: 'https://vimeo.com/13541364',
    metadata: {
      width: 1280,
      height: 720,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F13541364%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F13541364&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F77909438_1280.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=vimeo" width="1280" height="720" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'Disruptive by Design',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/77909438_1280.jpg',
      description:
        'WIRED Design Conference Title http://www.wired.com/epicenter/wiredbiz2010/ Movie :Takuya Hosogane http://www.hsgn.tk Music :Taoka Takashi http://web.me.com/digitaltaokatakashi/digitaltaokatakshi/digitaltaokatakashi%40mac.com.html Agency :BOW http://b-o-w.jp/# Tools :AfterEffects Cinema 4D',
      author_name: 'Takuya Hosogane',
    },
  },
  {
    url: 'https://vimeo.com/219302853',
    metadata: {
      width: 1280,
      height: 720,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F219302853%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F219302853&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F637019695_1280.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=vimeo" width="1280" height="720" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title:
        'Jeffrey Zeldman 20 years of Web Design and Community - an intimate portrait by lynda.com',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/637019695_1280.jpg',
      description:
        'from lynda.com: Who is Jeffrey Zeldman? The "Miles Davis of web design"? "Godfather of the web"? Or simply "your friend on the Internet"? For people who make websites, Zeldman is all of these and more. He\'s been a guiding voice in web design since the earliest days of the Internet, leading the charge in the fight for web standards.',
      author_name: 'Jeffrey Zeldman',
    },
  },
  {
    url: 'https://vimeo.com/153138303',
    metadata: {
      width: 1920,
      height: 1080,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F153138303%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F153138303&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F553337456_1280.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=vimeo" width="1920" height="1080" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'FITC // Toronto 2016 Teaser',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/553337456_1280.jpg',
      description:
        "FITC invited us to team up with Antfood to produce the titles for their 2016 Toronto conference. Here's a little teaser. Stay tuned for the main titles in April! Our man Jay will be speaking at the conference this year, so come throw rotten fruit at him if you're in town.",
      author_name: 'Giant Ant',
    },
  },
  {
    url: 'https://vimeo.com/123152125',
    metadata: {
      width: 1280,
      height: 720,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F123152125%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F123152125&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F516522056_1280.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=vimeo" width="1280" height="720" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'Motion Shapes - Animated Shape Elements [ Motion Graphics ]',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/516522056_1280.jpg',
      description:
        'Download Info ► http://goo.gl/dYnUgh A quick preview of some elements, here: http://bit.ly/1QO5KVe This package contains 300+ compositions ( 1000+ shape layers ) that will give an outstanding, beautiful and dynamic look to your motion video project.',
      author_name: 'MotionPatriot',
    },
  },
  {
    url: 'https://vimeo.com/68481134',
    metadata: {
      width: 1280,
      height: 720,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F68481134%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F68481134&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F440817676_1280.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=vimeo" width="1280" height="720" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'INSPIRATION',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/440817676_1280.jpg',
      description:
        'Personal Work. "INSPIRATION". All made in After effects, illustrator and Photoshop. Motion grapher: Rafa Galeano. http://cargocollective.com/rafagaleano Music: Charlie Parker - Summertime Bad Meets Evil - Living Proof BSN Posse X SkilL Joseph - Chapter III http://bsnposse.bandcamp.com/ Project extended: http://be.net/rafagaleano',
      author_name: 'Rafa Galeano',
    },
  },
  {
    url: 'https://vimeo.com/45698221',
    metadata: {
      width: 1280,
      height: 720,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F45698221%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F45698221&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F317907578_1280.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=vimeo" width="1280" height="720" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'What is motion graphics?',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/317907578_1280.jpg',
      description:
        "I made this video for my thesis but then my plans changed because of many reasons and I didn't use it. I was supported by Carlo De Agostini during the design phase.",
      author_name: 'Elisa Tron',
    },
  },
  {
    url: 'https://vimeo.com/114900089',
    metadata: {
      width: 1920,
      height: 1080,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F114900089%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F114900089&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F556340000_1280.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=vimeo" width="1920" height="1080" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'A Brief Lesson on Color Theory',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/556340000_1280.jpg',
      description:
        'School of Visual Arts motion graphics semester project on COLOR THEORY. View project: https://www.behance.net/gallery/22359445/Color-Theory-Motion Instructor: Ori Kleiner Music: Curious Notion Awards: New Talent Annual Graphis Inc. Gold / 2016 Design Achievement Awards Adobe Semifinalist / 2015',
      author_name: 'Rhea Lelina Manglapus',
    },
  },
  {
    url: 'https://vimeo.com/22960091',
    metadata: {
      width: 1280,
      height: 720,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F22960091%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F22960091&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F149151260_1280.jpg&key=c4e54deccf4d4ec997a64902e9a30300&type=text%2Fhtml&schema=vimeo" width="1280" height="720" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'Helvetica in Motion',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/149151260_1280.jpg',
      description:
        '1 minute animation using an interview snippet from the movie "Helvetica" of Mike Parker. Song by T.V. On The Radio: Love Dog.',
      author_name: '333',
    },
  },
  {
    url: 'https://vimeo.com/167788267',
    metadata: {
      width: 1920,
      height: 822,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F167788267%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F167788267&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F573331041_1280.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=vimeo" width="1920" height="822" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'The Color of California',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/573331041_1280.jpg',
      description:
        'Other than traffic, California is a beautiful place. Filmed entirely on RED. The shots in Yosemite were captured using the Highsight cable cam system, and a sunroof. Matt Pagan is the wave ripper and a local pro down in the LA area. Give him a follow on insta @matt_pagan.',
      author_name: 'Sean Slobodan',
    },
  },
  {
    url: 'https://vimeo.com/37058542',
    metadata: {
      width: 1280,
      height: 720,
      html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F37058542%3Fapp_id%3D122963&dntp=1&url=https%3A%2F%2Fvimeo.com%2F37058542&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F254415559_1280.jpg&key=c4e54deccf4d4ec997a64902e9a30300&type=text%2Fhtml&schema=vimeo" width="1280" height="720" scrolling="no" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="true"></iframe>',
      aspectRatio: 0,
      title: 'Experimental motion graphics',
      provider_name: 'Vimeo',
      type: 'video',
      thumbnail_url: 'https://i.vimeocdn.com/video/254415559_1280.jpg',
      description:
        "Inspired by 'Emigre', music by Ratatat, animated by Danielle Shami as part of a final project in Broadcast course at Shenkar school of design, 3rd year.",
      author_name: 'danielle Shami',
    },
  },
] as const;

export const links = [
  'https://webflow.com',
  'https://www.google.com',
  'https://www.youtube.com',
  'https://vimeo.com',
  'https://www.facebook.com',
  'https://www.yahoo.com',
  'https://www.amazon.com',
  'https://www.wikipedia.org',
  'https://twitter.com',
  'https://www.bing.com',
  'https://www.instagram.com',
  'https://www.ebay.com',
  'https://pinterest.com',
  'https://www.reddit.com',
  'https://paypal.com',
  'https://wordpress.com',
  'https://www.blogger.com',
  'https://www.tumblr.com',
  'https://www.apple.com/',
  'https://www.imdb.com/',
  'https://www.craigslist.org',
  'https://www.cnn.com',
  'https://dropbox.com',
  'https://adobe.com',
  'https://www.whatsapp.com',
] as const;

// Main google materials colors
export const colors = {
  red: '#F44336',
  pink: '#E91E63',
  purple: '#9C27B0',
  deepPurple: '#673AB7',
  indigo: '#3F51B5',
  blue: '#2196F3',
  lightBlue: '#03A9F4',
  cyan: '#00BCD4',
  teal: '#009688',
  green: '#4CAF50',
  lightGreen: '#8BC34A',
  lime: '#CDDC39',
  yellow: '#FFEB3B',
  amber: '#FFC107',
  orange: '#FF9800',
  deepOrange: '#FF5722',
  brown: '#795548',
  grey: '#9E9E9E',
  blueGrey: '#607D8B',
  black: '#000000',
  white: '#FFFFFF',
} as const;

export const postTitles = [
  '20 Myths About Web Design',
  'The History Of Web Design',
  "The Worst Advice We've Ever Heard About Web Design",
  '15 Best Blogs To Follow About Web Design',
  '14 Common Misconceptions About Web Design',
  'What Will Website Be Like In 100 Years?',
  'Why We Love Webflow (And You Should, Too!)',
  '7 Things About Web Design Your Boss Wants To Know',
  '7 of the Best Examples of Beautiful Blog Design',
  '5 Web Design Blogs You Should Be Reading',
  "10 Web Design Blogs You Can't Miss",
  '10 Quick Tips About Blogging',
  'How to improve Web Design Process',
  '5 Principles Of Effective Web Design',
  '10 Things Nobody Told You About Being a Web Designer',
  '7 Must Have Tools For Web Designers',
  '5 Great Web Design Resources',
  'Designers Who Changed the Web',
  '7 Ways To Improve Website Usability And Accessibility',
  '10 Great Examples of Responsive Websites',
] as const;

export const searchTitles = [
  "You're viewing sample results.",
  'Add CMS or Business Hosting and index your site to see real search results!',
  'Want more from search? Add your idea to our Wishlist',
  'Define a search image in Page Settings to add some imagery to results',
  'Search snippets too long? Limit their character count in the Settings panel',
  'You can exclude any page from site search in Page Settings',
  'Components and Collection Lists are excluded from site search by default',
  'Have a super-secret style guide on your site? Exclude it in Page Settings',
  'Highlight search terms in results in the Settings tab',
  "Pro tip: Tell people what they can search for in your search input's placeholder text!",
  'Write your own search input placeholder text in the Settings panel',
  'Want a shorter results list? Set a limit on results count in the Settings panel',
  'Empty states matter. Style yours in the Settings panel',
  'Pro tip: Keep the search form on your results page so people can try again',
  'Take a cue from Google: Keep the slugs in your results list',
  'Did you know you can test queries in the Settings panel?',
  'Search snippets look too long? Set a character limit in the Settings panel',
  "Your site search settings won't affect Google or other search engines",
  'Exclude whole Collections from search in Collection Page Settings',
  'You can set your search titles and snippets to match your SEO title and descriptions',
  'You can exclude any element from search in its settings!',
] as const;
